<template>
  <v-card style="margin-bottom: 24px">
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <CreateSubjectForm :state="dialog" @closeDialog="close" @refresh="refresh" />
      <UpdateSubjectForm :state="updateDialog" :data="subject" @closeDialog="closeUpdate" @refresh="refresh" />
      <h5 class="text-uppercase align-self-center">Danh sách môn thi</h5>
    </div>
    <div class="d-flex justify-end align-center pr-6">
      <v-btn color="primary" class="elevation-0" dark @click="openCreate">
        <v-icon left>mdi-plus</v-icon>Thêm môn thi</v-btn
      >
    </div>
    <div class="pa-6">
      <v-card>
        <v-data-table
          item-key="id"
          :headers="headers"
          :loading="loading"
          :items="subjects"
          :items-per-page="10"
          :disable-sort="$vuetify.breakpoint.smAndDown"
          :footer-props="{ 'items-per-page-text': 'Số nhóm mỗi trang' }"
          v-bind="this.$attrs"
        >
          <template v-slot:[`footer.page-text`]="items">
            Môn thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} môn
          </template>
          <template v-slot:[`item.grade`]="{ item }"> Khối {{ item.grade === 'secondary' ? '6' : '10' }} </template>
          <template v-slot:[`item.status`]="{ item }">
            {{ item | getStatus }}
          </template>
          <template v-slot:[`item.starTime`]="{ item }">
            {{ item | getTime }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" @click="update(item)" v-bind="attrs" v-on="on" icon>
                    <v-icon> mdi-pencil </v-icon>
                  </v-btn>
                </template>
                <span>Chỉnh sửa môn thi</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import { get } from 'lodash'
import moment from 'moment'
import CreateSubjectForm from './CreateSubjectForm.vue'
import UpdateSubjectForm from './UpdateSubjectForm.vue'

const originHeaders = [
  {
    text: 'Môn thi',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true,
    width: '25%'
  },

  {
    text: 'Giờ thi',
    value: 'starTime',
    align: 'left',
    sortable: false,
    show: true,
    width: '25%'
  },
  {
    text: 'Thao tác',
    value: 'actions',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  }
]

export default {
  props: {
    subjects: Array
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      dialog: false,
      updateDialog: false,
      subject: {
        name: '',
        grade: '',
        time: ''
      }
    }
  },
  created() {
    this.loading = true
  },
  methods: {
    update(item) {
      this.subject = item
      this.updateDialog = true
    },
    openCreate() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    closeUpdate() {
      this.updateDialog = false
    },
    refresh() {
      this.$emit('refresh')
    }
  },
  watch: {
    subjects(newVal) {
      if (newVal) {
        this.loading = false
      }
    }
  },
  filters: {
    getDesc: item => {
      return get(item, 'note', 'Chưa có thông tin')
    },
    getStatus: item => {
      if (item.status === 'active') {
        return 'Đang hoạt động'
      } else if (item.status === 'inActive') {
        return 'Đã bị khóa'
      } else if (item.status === 'removed') {
        return 'Đã bị xóa'
      } else {
        return ''
      }
    },
    getTime: item => {
      if (item.startTime) return moment(item.startTime).format('DD/MM/YYYY HH:mm:ss')
      return 'Chưa có thông tin'
    }
  },
  components: { CreateSubjectForm, UpdateSubjectForm }
}
</script>
